import { useContext } from 'react'
import { FetcherContext } from './context'
import type { TrackerFetcher } from './TrackerProvider.types'

export function useFetcher(): TrackerFetcher {
  const fetcher = useContext(FetcherContext)

  if (!fetcher) {
    throw new Error('useFetcher must be used within a <TrackerProvider>')
  }

  return fetcher
}
